import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=65c38c81&"
import script from "./FormUpload.vue?vue&type=script&lang=ts&"
export * from "./FormUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FormUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports